import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsCmConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static BURIAL_TYPE_LABEL = "Burial type";
    static BURIAL_DATE_LABEL = "Burial date";
    static FUNERAL_PARLOUR_LABEL = "Funeral Parlour";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static PAUPER_DECISION_LABEL = "Pauper decision";
    static PAUPER_DECISION_DATE_LABEL = "Pauper decision date";
    static IS_DOCUMENTATION_COMPLETE_LABEL = "Is the documentation complete?";
    static CEMETERY_LABEL = "Which cemetery / graveyard are you applying to?";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static BURIAL_TYPE_FORM_CONTROL_NAME = "burialType";
    static BURIAL_DATE_FORM_CONTROL_NAME = "burialDate";
    static FUNERAL_PARLOUR_FORM_CONTROL_NAME = "funeralParlour";
    static REFERENCE_NUMBER_FORM_CONTROL_NAME = "referenceNumber";
    static PAUPER_DECISION_FORM_CONTROL_NAME = "pauperDecision";
    static PAUPER_DECISION_DATE_FORM_CONTROL_NAME = "pauperDecisionDate";
    static IS_DOCUMENTATION_COMPLETE_FORM_CONTROL_NAME = "isDocumentationComplete";
    static CEMETERY_FORM_CONTROL_NAME = "cemeteryId";
    static DEFAULT_CEMETERY_NAME = "Any";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        burialDate: {
            required: `Burial date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        burialType: {
            required: `Burial type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        referenceNumber: {
            required: `Reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        pauperDecision: {
            required: `Pauper decision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        pauperDecisionDate: {
            required: `Pauper decision date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        isDocumentationComplete: {
            required: `Is the documentation complete ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
